<template>
  <div class="header-block">
    <NavBtn
      :img-url="avatar_src"
      :on-click="btnClick"
    />
    <section class="header">
      <div class="logo"><img src="//cdn.hongbaoxd.com/images/a6e1f6b38f3fd38d0f8a50d1965dd58b.png" alt="" /></div>
      <div class="ball-bg">
        <img src="//cdn.hongbaoxd.com/images/07b7d1a839d06dfc6a4d90a3a0b5f7fa.png" style="height: 128px;" alt="" />
      </div>
    </section>

    <section class="main-info">

      <div class="team triple-row">
        <div class="wallet">
          <div>我的余额</div>
          <div>
            <span>{{balance}}</span><span>元</span>
          </div>
          <div class="btn-small" @click="forward('/withdraw')">提现</div>
        </div>

        <div class="member">
          <div>我的徒弟</div>
          <div>
            <span @click="forward('/apprentice')">{{team_member_num}}</span><span>人</span>
          </div>
          <div class="btn-small" @click="$refs.share.show()">邀请</div>
        </div>

        <div class="money">
          <div>收徒奖励</div>
          <div>
            <span @click="forward('/commission')">{{team_money}}</span><span>元</span>
          </div>

          <div class="btn-small reward" v-if="team_money > 0" @click="rewardAmount">领取</div>
          <div class="btn-small disabled" v-if="team_money <= 0">领取</div>
        </div>

      </div>
    </section>
    <ShareDialog ref="share" />
    <RewardApprenticeDialog ref="reward" :amount ='amount'/>
  </div>
</template>
<style lang='scss' scoped>
  @import 'header';
</style>
<script>
import { mapState, mapActions } from 'vuex'
import ShareDialog from './popups/ShareDialog'
import { URI_TEAM_REWARD } from '@/store/modules/account/type'
import { URI_APPTASK_LIST } from '@/store/modules/dashboard/type'
import RewardApprenticeDialog from './popups/RewardApprenticeDialog'
// import { setUUID } from '../../assistant/JSBridge'
export default {
  data () {
    return {
      max: 0
    }
  },
  components: {
    ShareDialog,
    RewardApprenticeDialog
  },
  computed: {
    ...mapState({
      amount: state => state.account.amount,
      avatar: state => state.dashboard.taskInfo.avatar,
      balance: state => state.dashboard.taskInfo.balance,
      team_money: state => state.dashboard.taskInfo.team_money,
      team_member_num: state => state.dashboard.taskInfo.team_member_num
    }),
    'avatar_src': function () {
      return this.avatar === ''
        ? '//cdn.hongbaoxd.com/images/9fe384e3a5114f73814e2d212515b26d.png'
        : this.avatar
    }
  },
  methods: {
    ...mapActions({
      teamReaward: URI_TEAM_REWARD,
      getAccount: URI_APPTASK_LIST
    }),
    // setUUID('')
    // 领取奖励金额
    async rewardAmount () {
      const res = await this.teamReaward()
      if (res && res.status === 200) {
        if (typeof (res) === 'undefined') return
        if (typeof (res) !== 'undefined') {
          this.$refs.reward.show()
          this.getAccount()
        }
      }
    },
    forward (path) {
      this.$router.push(path)
    },
    btnClick () {
      $router.push('/user')
    }
  }
}
</script>
